import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Popup } from '_atoms';
import { Typography } from '_atoms/Typography';
import './style.scss';

interface PopupConfirmInterviewUserData {
  first_name_latin?: string;
  last_name_latin?: string;
  first_name_local?: string;
  last_name_local?: string;
}

interface PopupConfirmInterviewProps {
  open: boolean;
  startDate: string | null;
  endDate: string | null;
  userData: PopupConfirmInterviewUserData;
  onClose: () => void;
  onConfirm: () => void;
}

export const PopupConfirmInterview: React.FC<PopupConfirmInterviewProps> = ({
  open,
  startDate,
  endDate,
  userData,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const date = `${moment(startDate).format('ddd MMM DD, YYYY H:mm')} – ${moment(endDate).format('H:mm')}`;
  return (
    <Popup
      className="popup-confirm-interview"
      open={open}
      title={t('translation:popup_confirm_interview.title')}
      cancelButtonProps={{ onClick: onClose, children: t('translation:popup_confirm_interview.button_cancel') }}
      okButtonProps={{ onClick: onConfirm, children: t('translation:popup_confirm_interview.button_confirm') }}
    >
      <div className="user-info">
        <Typography.Text className="user-info__title">{`${userData.first_name_latin} ${userData.last_name_latin}`}</Typography.Text>
        <Typography.Caption className="user-info__subtitle">{`${userData.first_name_local} ${userData.last_name_local}`}</Typography.Caption>
      </div>
      <div className="info-block">
        <Typography.Label>{t('translation:popup_confirm_interview.label_date_and_time')}</Typography.Label>
        <Typography.Text>{date}</Typography.Text>
      </div>
      <Typography.Text>{t('translation:popup_confirm_interview.text_confirm_interview')}</Typography.Text>
    </Popup>
  );
};
